









































import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { TripTypeEnum } from "@/lib/enum/trip-type.enum";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportTripDetails extends ReportStepMixin implements IReportStep {
  header: IReportHeaderData = {
    title: "report.tripDetails.title",
    description: "report.tripDetails.description"
  };

  screen = ReportScreenEnum.tripDetails;
  valid = false;

  tripTypeOptions = [
    { text: this.$t(`enums.TripTypeEnum.${TripTypeEnum.BUSINESS}`), value: TripTypeEnum.BUSINESS },
    { text: this.$t(`enums.TripTypeEnum.${TripTypeEnum.PRIVATE}`), value: TripTypeEnum.PRIVATE },
    { text: this.$t(`enums.TripTypeEnum.${TripTypeEnum.COMMUTE}`), value: TripTypeEnum.COMMUTE }
  ];

  get requiredRule() {
    return [requiredRule()];
  }

  get isDone() {
    return (
      this.valid &&
      this.tripType !== undefined &&
      this.isValidDriversLicense !== undefined &&
      this.isUnderInfluence !== undefined
    );
  }

  get tripType(): TripTypeEnum | undefined {
    return ReportModule.tripType;
  }

  set tripType(type: TripTypeEnum | undefined) {
    ReportModule.setTripType(type);
  }

  get isValidDriversLicense(): boolean | undefined {
    return ReportModule.isValidDriversLicense;
  }

  set isValidDriversLicense(value: boolean | undefined) {
    ReportModule.setIsValidDriversLicense(value);
  }

  get isUnderInfluence(): boolean | undefined {
    return ReportModule.isUnderInfluence;
  }

  set isUnderInfluence(value: boolean | undefined) {
    ReportModule.setIsUnderInfluence(value);
  }
}
